import { render, staticRenderFns } from "./flats-crm-section-home-page.vue?vue&type=template&id=08778003"
import script from "./flats-crm-section-home-page.vue?vue&type=script&lang=js"
export * from "./flats-crm-section-home-page.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-section-home-page.vue?vue&type=style&index=0&id=08778003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports